/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";

const EditIcon = ({
  size = "small",
  color = "",
  className = "",
  height = "18",
  width = "18",
  fill = "",
  testId = "edit-icon",
}) => {
  let iconSizeClassName;
  if (size === "small") {
    iconSizeClassName = "w-5 h-5";
  } else {
    iconSizeClassName = "w-7 h-7";
  }

  return (
    <svg
      className={cn(iconSizeClassName, className)}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      test-id={testId}
    >
      <path
        d="M2.49063 15.5068H3.76735L11.6328 7.63014L10.3561 6.3516L2.49063 14.2283V15.5068ZM15.5314 6.30593L11.6556 2.47032L12.9324 1.19178C13.2819 0.841702 13.7115 0.666664 14.2209 0.666664C14.7298 0.666664 15.159 0.841702 15.5086 1.19178L16.7853 2.47032C17.1349 2.82039 17.3173 3.24292 17.3325 3.7379C17.3477 4.23227 17.1805 4.65449 16.8309 5.00456L15.5314 6.30593ZM14.2091 7.65297L4.5425 17.3333H0.666748V13.4521L10.3333 3.77169L14.2091 7.65297Z"
        fill={fill || color || "white"}
      />
    </svg>
  );
};

export default EditIcon;
